import { useMemo, useState } from 'react';

interface AllSessions {
  created: string;
  updated: string;
  status: string;
  bestMatch?: string;
  name: string;
  sessionULID: string;
  lastStep?: string;
}
export const useSortableData = (items: AllSessions[], config: any = null) => {
  const [sortConfig, setSortConfig] = useState(config);

  const sortedItems = useMemo(() => {
    const sortableItems = [...items];
    if (sortConfig !== null) {
      sortableItems.sort((a, b) => {
        if ((a as any)[sortConfig.key].toLowerCase() < (b as any)[sortConfig.key].toLowerCase()) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if ((a as any)[sortConfig.key].toLowerCase() > (b as any)[sortConfig.key].toLowerCase()) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableItems;
  }, [items, sortConfig]);

  const requestSort = (key: any) => {
    let direction = 'ascending';
    if (
      sortConfig &&
      sortConfig.key === key &&
      sortConfig.direction === 'ascending'
    ) {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  return { items: sortedItems, requestSort, sortConfig };
};
